<script>
  import * as PropTypes from "prop-types";
  import Avatar from "@/components/atoms/Avatar.svelte";
  import { _normalizeNumber, appendWidthParam } from "@/utils";
  import { onMount } from "svelte";
  export let item;
  export let handle;
  const { checkPropTypes, object, string } = PropTypes;
  const propTypes = {
    item: object,
    handle: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Profile");
  });

  $: stats = [
    {
      v: _normalizeNumber(item.a),
      t: "Followers",
      testId: "followers",
    },
    {
      v: _normalizeNumber(item.b),
      t: "Following",
      testId: "following",
    },
    {
      v: _normalizeNumber(item.likeCount),
      t: "Likes",
      testId: "likes",
    },
  ];
  const smallTextClasses = `text-[12px] md:text-[15px] text-[#8a8a8f]`;
</script>

<div class="flex mb-10 px-xs" data-testid="profile-section">
  <div
    class="max-w-full w-[100px] h-[100px] md:w-[148px] md:h-[148px]"
    data-testid="avatar"
  >
    <Avatar
      src={appendWidthParam(item.tu, "120")}
      width="w-[100px] max-w-full md:w-[148px]"
      height="h-[100px] md:h-[148px]"
      flexShrink="shrink"
    />
  </div>

  <div class="pl-5 md:pl-10 overflow-hidden">
    <div
      class="flex items-center text-[16px] md:text-[24px] font-bold break-words"
      data-testid="user-handle"
    >
      @{handle}
      {#if item.badgeUrl}
        <img class="h-[22px] w-[22px] ml-xs" src={item.badgeUrl} alt="Badge" />
      {/if}
    </div>
    <div
      class="text-[14px] md:text-[15px] font-bold mt-xxs break-words"
      data-testid="user-name"
    >
      {item.n}
    </div>
    <div class="flex flex-wrap my-lg" data-testid="social-media-stats">
      {#each stats as stat, i}
        <div
          class={i < stats.length - 1 ? "pr-md md:pr-11" : ""}
          data-testid={stat.testId}
        >
          <h4 class={`font-bold text-[16px] md:text-[18px] uppercase`}>
            {stat.v}
          </h4>
          <p class={smallTextClasses}>{stat.t}</p>
        </div>
      {/each}
    </div>
    <p
      class={`${smallTextClasses} whitespace-pre-wrap break-words`}
      data-testid="user-bio"
    >
      {item.s || ""}
    </p>
  </div>
</div>
